export default __webpack_public_path__ + "static/media/bw-reaction-speed-tutorial-pop-up-step-2.2f1cba77.svg";